const roleOptions = [
  { label: "Super Administrator", value: "super_admin" },
  { label: "Administrator", value: "admin" },
  { label: "Staff", value: "staff" },
  { label: "Provider", value: "provider" },
];

export default roleOptions;
